import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import { Link, withRouter, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { driverFaqData } from './DriverFaqData';
import { driverFaqDataNYC } from './DriverFaqDataNYC';
import arrowDown from '../../../images/arrow-down-black.svg';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import Header from '../../NewProfile/Header';
import SideBarContent from '../../SideBar/SideBarContent';
import ScrollLock from 'react-scrolllock';
import qs from 'query-string';
import './driverFaq.css';
import { driverFaqDataSF } from './DriverFaqDataSF';
import { driverFaqDataOTT } from './DriverFaqDataOTT';

class DriverFaq extends Component {
  constructor(props) {
    super(props);
    this.state = {
      input: '',
      openLate: false,
      toggleLate: true
    };
  }

  componentDidMount() {
    const values = qs.parse(this.props.location.search);

    if (values.section === 'latePolicy') {
      let element = document.getElementById('late-policy');

      element.click();
      let element2 = document.getElementById('panel3title1');
      element2.scrollIntoView(true);
    }

    if (values.section === 'evCharging') {
      let element = document.getElementById('autzu-ev-charging-policy');

      element.click();
      let element2 = document.getElementById('panel3title1');
      element2.scrollIntoView(true);
    }
  }

  handleChange = e => {
    this.setState({ input: e.target.value });
  };

  handleResults = faqArr => {
    if (this.state.input) {
      const resultArr = [];
      faqArr.forEach(e => {
        resultArr.push(...e.content);
      });
      // console.log(
      //   resultArr.map(a =>
      //     a.info[0].component ? a.info[0].component : a.info
      //   )
      // );
      const searchResults = [
        {
          heading: 'Search Results',
          content: resultArr.filter(
            val =>
              _.includes(
                val.title.toLowerCase(),
                this.state.input.toLowerCase()
              ) ||
              _.includes(
                val.info[0].component
                  ? val.info[0].component.toString().toLowerCase()
                  : JSON.stringify(val.info).toLowerCase(),
                this.state.input.toLowerCase()
              ) ||
              (val.info[0].subData &&
                val.info[0].subData.filter(
                  item =>
                    _.includes(
                      item.title.toLowerCase(),
                      this.state.input.toLowerCase()
                    ) ||
                    _.includes(
                      item.Content.toString().toLowerCase(),
                      this.state.input.toLowerCase()
                    )
                ))
          )
        }
      ];
      console.log(searchResults);
      return this.renderResults(searchResults);
    }
    return this.renderResults(faqArr);
  };

  renderResults = data =>
    data.map((data, index1) => (
      <div id={`accordion${index1}`}>
        <div
          className="panel-heading"
          id={data.heading
            .split(' ')
            .join('-')
            .toLowerCase()}>
          <h4 className="faq__section-title">{data.heading}</h4>
        </div>
        <div className="panel-collapse collapse in">
          <div className="panel-body">
            <div className="panel-group">
              {data.content.map((content, index2) => (
                <div
                  className="faq__panel"
                  id={`panel${index1}title${index2}`}
                  key={content}>
                  <div
                    className={
                      this.state.input
                        ? 'faq__heading'
                        : 'faq__heading collapsed'
                    }
                    data-toggle="collapse"
                    href={`#panel${index1}Faq${index2}`}
                    id={content.title
                      .split(' ')
                      .join('-')
                      .toLowerCase()}>
                    <h4 className="faq__panel--title">{content.title}</h4>
                    <FontAwesomeIcon
                      className="faq__arrow"
                      icon={faChevronDown}
                    />
                    <img
                      className="faq__arrow hide"
                      src={arrowDown}
                      alt="arrow"
                    />
                  </div>
                  <div
                    id={`panel${index1}Faq${index2}`}
                    className={
                      this.state.input
                        ? 'panel-collapse collapse in'
                        : 'panel-collapse collapse '
                    }>
                    <div className="faq__panel--body">
                      {content.info.map((info, index) => {
                        // Custom Component
                        const ListComponent = info.component;
                        if (info.component) {
                          return <ListComponent key={info} />;
                        }
                        //Sub component
                        if (info.subData) {
                          return info.subData.map(
                            ({ title, Content }, index) => (
                              <div
                                className="faq__panel faq__panel__margin"
                                key={title}>
                                <div
                                  className="faq__heading collapsed"
                                  data-toggle="collapse"
                                  href={`#startVehicleFaq${index}`}>
                                  <h4 className="faq__panel--title">
                                    {title}
                                  </h4>
                                  <FontAwesomeIcon
                                    className="faq__arrow"
                                    icon={faChevronDown}
                                  />
                                  <img
                                    className="faq__arrow hide"
                                    src={arrowDown}
                                    alt="arrow"
                                  />
                                </div>
                                <div
                                  id={`startVehicleFaq${index}`}
                                  className="panel-collapse collapse ">
                                  <div className="faq__panel--body">
                                    <Content key={title} />
                                  </div>
                                </div>
                              </div>
                            )
                          );
                        }

                        // Plain Text
                        if (info.text) {
                          return <p key={info.text}> {info.text}</p>;
                        }
                        // Text with link inside
                        if (info.link) {
                          return (
                            <p key={info.link}>
                              {' '}
                              {info.link.leadingText}
                              <a
                                className="faq__panel--link"
                                href={info.link.href}>
                                {' '}
                                {info.link.title}
                              </a>
                              {info.link.trailingText}
                            </p>
                          );
                        }
                        // Action button at bottom of FAQ
                        if (info.button) {
                          return (
                            <Link to={info.button.href} key={info.button}>
                              <button className="faq__panel--button">
                                {' '}
                                {info.button.title}
                              </button>
                            </Link>
                          );
                        }

                        // If Image
                        if (info.image) {
                          return (
                            <img
                              className="faq-image"
                              src={info.image.src}
                              alt={info.image.alt}
                            />
                          );
                        }
                        return null;
                      })}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    ));

  faq = () => {
    const { history, operatingCity } = this.props;
    return (
      <Fragment>
        <Helmet>
          <title>Help | Autzu</title>
          <meta
            name="description"
            content="Get all the answers to your frequently asked driving questions."
          />
        </Helmet>
        <div className="driverFaq">
          {/dfaq/.test(window.location.href) ? null : (
            <Header
              persistentTitle
              title="Help"
              back
              onClick={() => {
                history.goBack();
              }}
            />
          )}
          <ScrollLock>
            <div
              className="driverFaq__body container driverFaq__scroll"
              style={
                /dfaq/.test(window.location.href)
                  ? { marginTop: '0' }
                  : null
              }>
              <div className="driverFaq__container">
                {/* <div className="faq__title">
                    <h2 className="faq__title--bold">Help</h2>
                  </div> */}
                <div className="driverFaq__sidebar">
                  <SideBarContent
                    status={this.props.status}
                    signedIn={this.props.loggedIn}
                  />
                </div>
                <div
                  className="driverFaq__content--container"
                  style={
                    /dfaq/.test(window.location.href)
                      ? { padding: '24px' }
                      : null
                  }>
                  <div className="faq__title__search">
                    <div className="faq__title__search__header">
                      <h2 className="faq__title__search__header--h2">
                        Help
                      </h2>
                    </div>
                    <div className="faq__title__search__bar">
                      <FontAwesomeIcon
                        icon={faSearch}
                        className="faq__title__search__bar__icon"
                      />
                      <input
                        className="faq__title__search__bar__search-form"
                        type="text"
                        placeholder="Search"
                        value={this.state.input}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                  {operatingCity === 'tor'
                    ? this.handleResults(driverFaqData)
                    : operatingCity === 'sf'
                    ? this.handleResults(driverFaqDataSF)
                    : operatingCity === 'ott'
                    ? this.handleResults(driverFaqDataOTT)
                    : this.handleResults(driverFaqDataNYC)}
                </div>
              </div>
            </div>
          </ScrollLock>
        </div>
      </Fragment>
    );
  };

  render() {
    return <this.faq />;
  }
}

export default withRouter(DriverFaq);



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/index.js